"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._assert = exports.artifactType = exports.nodeType = void 0;
exports.nodeType = 'file_dataLakeTape';
exports.artifactType = 'dataLakeTape';
// we omit and redefine types from DbTable.ArtifactWithSlugs => IntermediateRecord
// this type assertion below helps ensure that we din't miss any fields.
exports._assert = {};
//# sourceMappingURL=types.js.map